/**
 * @author Zdenka Valkučáková <zdenka.valkucakova@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { parseCronExpression } from 'cron-schedule';
import { TimerBasedCronScheduler } from 'cron-schedule/schedulers/timer-based.js';

/**
 * @import { ContentInfo } from '../../content/info/content-info'
 * @import { Logger } from '../../logger/logger'
 * @import ReplacerPower from '../power/replacer-power'
 * @import { RebootCronTask } from '../../reboot'
 */

/**
 * @typedef {Pick<ContentInfo, 'rebootTasks'>} IContentInfo
 * @typedef {ReturnType<typeof TimerBasedCronScheduler.setTimeout>} TimerHandle
 */

export default class ReplacerReboot {
  /**
   * @param {Logger} logger
   * @param {ReplacerPower} replacerPower
   */
  constructor(logger, replacerPower) {
    this.logger = logger;
    this.replacerPower = replacerPower;
    /** @type {TimerHandle[]} */
    this.timerHandles = [];
    this.onError = this.onError.bind(this);
  }

  /**
   * @private
   */
  clearTasks() {
    this.timerHandles.forEach(TimerBasedCronScheduler.clearTimeoutOrInterval);
    this.timerHandles = [];
  }

  /**
   * @private
   * @param {Error | unknown} error
   */
  onError(error) {
    this.logger.error(error);
  }

  /**
   * @param {IContentInfo} contentInfo
   */
  async replace(contentInfo) {
    this.clearTasks();
    await this.scheduleTasks(contentInfo.rebootTasks);
  }

  /**
   * @private
   * @param {RebootCronTask[]} rebootTasks
   */
  scheduleTasks(rebootTasks) {
    rebootTasks.forEach((rebootTask) => {
      this.timerHandles.push(
        TimerBasedCronScheduler.setInterval(
          parseCronExpression(rebootTask),
          () => this.replacerPower.reboot(),
          { errorHandler: this.onError }
        )
      );
    });
  }
}
